module.exports = __webpack_public_path__ + "8de750760ab171b7fad574145bb2992c.png";